export default __webpack_public_path__ + "static/wealth-phone-7d7d5652ac93f57655274a56cb52a2bd.svg";